import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types: AnalyticsTypes, Creators: AnalyticsActions } = createActions(
  {
    logGTMEvent: ['event', 'params'],
    logIntercomEvent: ['event', 'params'],
    logFilteredViewedExperiences: ['startIndex', 'endIndex'],
    logMarketViewedExperiences: ['startIndex', 'endIndex'],
    logKioskViewedExperiences: ['experiences'],
  },
  { prefix: 'ANALYTICS_' }
);

export const INITIAL_STATE = Immutable({});

export const reducer = createReducer(INITIAL_STATE, {});
